import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import GroupContext from "../../context/group/GroupContext";
import Preloader from "./../layout/Preloader";
import ActionMenu from "./../layout/ActionMenu";
import useForm from "../../hooks/useForm";
import useTokenCheck from "../../hooks/useTokenCheck";
import usePageTitle from "../../hooks/usePageTitle";

const Group = (props) => {
  const authContext = useContext(AuthContext);
  const { token } = authContext;
  const configContext = useContext(ConfigContext);
  const { getConfigValueByCode, getConfigValueByNameSponser } = configContext;
  const alertContext = useContext(AlertContext);
  const { setAlert, clearAlerts, setAlertTarget } = alertContext;
  const groupContext = useContext(GroupContext);
  const { groupsLoading, selectedGroup, createGroup, updateGroup, getGroups } =
    groupContext;
  const history = useHistory();
  console.log("###Current Group:", selectedGroup);
  const [group, setGroup] = useState({
    groupname: selectedGroup ? selectedGroup.groupname : "",
    groupdetails: selectedGroup ? selectedGroup.groupdetails : "",
    id: selectedGroup ? selectedGroup.id : "",
  });
  const { groupname, groupdetails, id } = group;

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Group Details",
  });

  const groupnameRef = useRef(null);
  const groupdetailsRef = useRef(null);
  const [valueChanged, setValueChanged] = useState(false);
  const onChange = (e) => {
    setGroup({ ...group, [e.target.name]: e.target.value });
    setValueChanged(true);
  };

  const cancelAction = async () => {
    clearAlerts();
    history.goBack();
  };

  const loadGroupDetail = async () => {
    try {
      const res = await getGroups(
        { filterType: "all", filterValue: "" },
        token
      );
      console.log("$$RES: ", res);
      if (res.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          res.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      } else if (res.length === 0) {
        clearAlerts();
        const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 469);
        setAlert(msg, "warning");
      }
    } catch (err) {
      console.log("$ERR:", err);
      if (err.msgCode) {
        const msg = getConfigValueByCode(
          "generalConfig",
          "RESPONSE_MSG",
          err.msgCode
        );
        clearAlerts();
        setAlert(msg, "warning");
      }
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 475);
      setAlert(msg, "danger");
    }
  };
  const { hasTokenExpired } = useTokenCheck();
  const submitForm = async (e) => {
    await hasTokenExpired();
    if (groupname !== "") {
      console.log("Submitting group", group);
      clearAlerts();
      try {
        let res = null;
        if (id !== "") {
          res = await updateGroup(group, token);
        } else {
          res = await createGroup(group, token);
        }
        console.log("$$RES: ", res);
        let msg = "";
        if (res && res.msgCode) {
          msg = getConfigValueByCode(
            "generalConfig",
            "RESPONSE_MSG",
            res.msgCode
          );
          console.log("$$msg: ", res);
          msg = msg.replace("{0}", res.data?.groupname);
        }
        clearAlerts();
        if (!msg) {
          msg = `Successfully ${id ? "updated" : "created"} the group`;
        }
        setAlertTarget(
          msg,
          res.status === "ERROR" ? "danger" : "info",
          "/group_mgmt"
        );
        setValueChanged(false);
        loadGroupDetail();
        history.goBack();
      } catch (err) {
        console.log("$ERR:", err.message);
        // const msg = getConfigValueByCode(
        //   "generalConfig",
        //   "RESPONSE_MSG",
        //   500
        // );
        clearAlerts();
        setAlertTarget("Unexpected Error Occured", "danger", "/group_mgmt");
      }
    }
  };

  const {
    Popup,
    validateField,
    validateAllFields,
    isFormValid,
    setIsFormValid,
  } = useForm({
    inputList: {
      groupname: groupnameRef,
      groupdetails: groupdetailsRef,
    },
    screenName: "create_group",
  });

  useEffect(() => {
    const isValid = validateAllFields();
    setIsFormValid(isValid);
    console.log("Form is valid", isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  const [labels, setLabels] = useState({
    groupName: "",
    groupDetails: "",
  });
  useEffect(() => {
    clearAlerts();
    let groupName = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.groupName"
    );
    let groupDetails = getConfigValueByNameSponser(
      "generalConfig",
      "Label",
      "label.groupDetails"
    );
    setLabels({ ...labels, groupName, groupDetails });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      <Popup />
      {groupsLoading && <Preloader />}
      <ActionMenu resetUseIdleTimer={props.resetUseIdleTimer} />
      <div
        className="patronPage"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 id="pageHeader" className="privateView__pageTitle">
          {selectedGroup ? "UPDATE GROUP DETAILS" : "CREATE GROUP"}
          <div className="privateView__pageTitle__note">
            {/* <span className="required">*</span>denotes a required field */}
          </div>
        </h1>
        <div className="patronPage__content">
          <div className="patronPage__card_row_4_col_2">
            <h2 className="patronPage__cardTitle">GROUP INFORMATION</h2>
            <div className="patronPage__card_form">
              <div id="groupForm" className="password__formBody">
                <form>
                  <div className="password__formBody__formGroup">
                    <label htmlFor="groupname">
                      {labels.groupName}
                      <span className="required" aria-label="Input required">
                        (*Required)
                      </span>
                      :{" "}
                    </label>
                    <input
                      type="text"
                      name="groupname"
                      id="groupname"
                      className="form-control"
                      placeholder={labels.groupName}
                      onChange={onChange}
                      value={groupname}
                      onBlur={validateField}
                      ref={groupnameRef}
                      aria-required="true"
                    />
                  </div>
                  <div className="password__formBody__formGroup">
                    <label htmlFor="groupdetails">{labels.groupDetails}:</label>
                    <input
                      type="text"
                      name="groupdetails"
                      id="groupdetails"
                      className="form-control"
                      placeholder={labels.groupDetails}
                      onChange={onChange}
                      value={groupdetails}
                      onBlur={validateField}
                      ref={groupdetailsRef}
                      aria-required="true"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="patronPage__card_action_bottom">
              <input
                className="btn btn-primary"
                type="button"
                value="BACK"
                onClick={cancelAction}
              ></input>
              <input
                className="btn btn-primary"
                name="SAVE"
                type="submit"
                value={id ? "SAVE" : "CREATE"}
                onClick={submitForm}
                disabled={!isFormValid || !valueChanged}
              ></input>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Group;
